// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__C5gLn","overflowing":"ReadFullNote_overflowing__1Nfbs"};